import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_LOGIN, CLIP_OFFER } from '../redux/reducers/offer';
import { SET_USER } from '../redux/reducers/user';
import { trackClick } from '../utils/gaTrackingFunctions';

function LoginModal(props) {
  const isLoggedIn = useSelector((state) => !!state.user.username);
  const siteConfig = props.page;
  const offerBlock = siteConfig.components.find((component) => component.block_type === 'OfferBlock');
  const dispatch = useDispatch();
  const {
    offer: { show_login: show, mdid, location, isBulkClip },
    config: {
      retailer: { id: retailerId },
    },
  } = useSelector((state) => state);


  const availableOffers = useSelector((state) => state.offer.collections.available);
  const selectedOffer = availableOffers.find((offer) => offer.mdid === mdid);

  let expiration_month, expiration_day, expiration_year;

  if (selectedOffer && selectedOffer.expirationDate) {
    const expiration = new Date(selectedOffer.expirationDate.iso);
    expiration_month = expiration.getMonth() + 1;
    expiration_day = expiration.getDate();
    expiration_year = expiration.getFullYear().toString().substr(2, 4);
  }
  

  const handleClose = () => {
    setLoginError(false);
    dispatch(SHOW_LOGIN({ show: false }));
  };

  let rememberUser = useRef(false);
  let [username, setUserName] = useState();
  let [loginError, setLoginError] = useState('');
  const mpid = siteConfig.mpId;
  let funnel = siteConfig.funnel ? siteConfig.funnel : 'n/a';
  let channel = siteConfig.funnel ? siteConfig.funnel : 'n/a';
  const colorTheme = siteConfig.components.find((component) => component.block_type === 'ColorTheme');

  function handleValidation() {
    if (username) {
      const sanitizedUsername = username.replace(/\D/g, '');
      if (sanitizedUsername.length < 10) {
        setLoginError('Please enter a valid 10-digit phone number');
        return; // Exit the function if the input is invalid
      }
  
      if (isBulkClip) {
        // Clip all available offers
        console.log(availableOffers);
        availableOffers.forEach((offer) => {
          dispatch(
            CLIP_OFFER({
              endpoint: 'offers/load',
              method: 'POST',
              body: {
                id: offer.mdid,
                username: sanitizedUsername,
                mediaPropertyId: mpid,
                channel: channel,
                funnel: funnel,
                location: 'bulk_offer_clip',
              },
            })
          );
        });

        dispatch(SET_USER({ state: 2, username: sanitizedUsername }));
        if (rememberUser.current.checked) {
          saveToStorage(sanitizedUsername, JSON.stringify(availableOffers[0].mdid));
        }
        trackLoginEvent();
        handleClose();
      } else {
        const options = {
          endpoint: 'offers/load',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-retailer': retailerId,
            Origin: window.location.origin,
          },
          body: {
            username: sanitizedUsername,
            id: mdid,
            mediaPropertyId: mpid,
            channel: channel,
            funnel: funnel,
          },
        };

        dispatch(CLIP_OFFER(options)).then((resp) => {
          if (resp.payload.success) {
            dispatch(SET_USER({ state: 2, username: sanitizedUsername }));
            if (rememberUser.current.checked) {
              saveToStorage(sanitizedUsername, JSON.stringify(resp.payload.mdid));
            }
            trackLoginEvent();
            handleClose();
          } else {
            setLoginError(resp.payload.errorMsg);
          }
        });
      }
    } else {
      setLoginError('Member Id required');
    }
  }
  
  function saveToStorage(username, mdid) {
    const sanitizedUsername = username.replace(/\D/g, '');
    const obj = { username: sanitizedUsername, myIds: mdid };
    localStorage.setItem('pbyt', JSON.stringify(obj));
  }
  function RenderLoginError() {
    if (loginError) {
      return <div>{loginError}</div>;
    }
    return '';
  }
  function trackLoginEvent (){
    window.gtag('event', 'account_login', { 
      retailer_id: "Publix",
      version: localStorage.getItem("AB_TEST_VARIABLE") || 'N/A',
    });
  }
  if (show) {

    return (
      
      <div className={`modal fade ${show ? 'show' : ''}`} id="loginModal" style={{ display: show ? 'block' : 'none' }} role="dialog">
        <div className="modal-dialog modal-dialog-centered">
        <div className={`fixed inset-0 flex items-center justify-center z-50 ${show ? 'visible' : 'invisible'}`}>
          <div className="modal-content w-[374px] xl:w-[1200px] p-6 xl:p-16 bg-white rounded-3xl shadow border-0 gap-6 mx-auto">
            <div className="flex flex-col gap-6 xl:flex-row xl:gap-16">
              <div className='image-section'>
              <button
                type="button"
                className="absolute top-4 right-4 bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none"
                onClick={handleClose}
                aria-label="Close"
              >
                <span className="sr-only">Close menu</span>
                <img src="/images/close_modal.svg" alt="Close" width="12" height="12" />
              </button>
                <div className="self-stretch h-56 xl:h-auto px-6 pt-6 flex-col justify-center items-center gap-2.5 flex">
                  <img className="w-[200px] h-[200px] xl:w-[400px] xl:h-[400px]" src={selectedOffer.enhancedImageUrl} />
                </div>
              </div>
              <div className='content-section xl:w-[504px] space-y-6 xl:flex xl:flex-col xl:justify-center'>
                <div className="text-left space-y-1">
                  <div className="text-zinc-800 text-[21px] xl:text-[31px] font-bold font-['Switzer Variable'] leading-[23.10px] xl:leading-[34.10px]"> {selectedOffer.brand} </div>
                  <div className="self-stretch text-zinc-800 text-base xl:text-lg xl:leading-[28.8px] font-normal font-['Switzer Variable'] leading-relaxed">{selectedOffer.description}</div>
                  <div className="text-gray-500 text-sm font-normal font-['Switzer Variable'] leading-snug">Expires: {expiration_month}/{expiration_day}/{expiration_year} </div>
                </div>
                  
                {!isLoggedIn && (
                  <form className="space-y-3">
                    <div>
                      <div className="w-full h-[58px] p-4 bg-white rounded-lg border border-gray-400 justify-start items-center gap-2 inline-flex">
                        <input
                          type="tel"
                          className="text-zinc-800 font-['Switzer Variable'] outline-none border-none"
                          placeholder="555-555-5555"
                          value={username}
                          onChange={(e) => {
                            let input = e.target.value.replace(/\D/g, '');
                            input = input.slice(0, 10);
                            let formattedInput = '';
                            for (let i = 0; i < input.length; i++) {
                              if (i === 3 || i === 6) {
                                formattedInput += '-';
                              }
                              formattedInput += input[i];
                            }
                            setUserName(formattedInput);
                            // checkModalValidation(e);
                          }}
                          maxLength={12}
                          required
                        />
                      </div>
                      <div className="text-left text-gray-500 text-sm font-normal font-['Switzer Variable'] leading-snug mt-1">
                        Enter the 10 digit phone number associated with your Club Publix account.
                      </div>
                    </div>
        
                    <div className="mb-0 text-red-500 text-lg font-normal leading-none">
                      <RenderLoginError />
                    </div>
                  </form>
                )}
      
                <button
                  className="w-[326px] xl:w-[504px] h-[58px] bg-black rounded-[200px] border border-gray-400 justify-center items-center inline-flex text-center text-white text-base font-bold font-['Switzer Variable'] leading-relaxed outline-none"
                  style={{
                    backgroundColor: colorTheme.primary_color,
                    color: colorTheme.primary_button_text_color,
                  }}
                  onClick={handleValidation}
                >
                  Clip Coupon
                </button>
      
                <div className="flex flex-col gap-1">
                  {!isLoggedIn && (
                    <div className="flex items-center">
                      <div className="text-zinc-800 xl:text-lg font-normal">Don't have a Club Publix account?</div>
                      <div className="text-black xl:text-lg font-bold underline ml-1">
                        <a href="https://www.publix.com/myaccount/register" target="_blank" style={{ color: 'black' }} onClick={() => trackClick('retailer_registration', 'popup')}>Join now</a>
                      </div>
                    </div>
                  )}
                  <div className="text-left text-gray-500 text-sm">Terms & Conditions apply</div>
                </div>
              </div>
              </div> {/*  THIS is content div end */}
              </div>
            </div> {/*  THIS is content div end */}
        </div>
        
        
      </div>
    );
    
  }

  return '';
}
export default LoginModal;
